var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerOfflineAssetHasDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8395C0 7.5393 7.5393 0 16.8395 0C26.1397 0 33.679 7.5393 33.679 16.8395C33.679 26.1397 26.1397 33.679 16.8395 33.679C7.5393 33.679 0 26.1397 0 16.8395Z",
    fill: "#979797",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 7.2C22.5 5.1 19.8 4 16.9 4C13.9 4 11.3 5.1 9.09995 7.2C6.79995 9.3 5.69995 12.1 5.69995 15.3C5.69995 17.7 6.59995 20.2 8.29995 22.7C9.89995 25 12.3 27.5 15.6 30.2L16.9 31.3L18.2 30.2C21.4 27.5 23.9 25 25.5 22.7C27.2 20.2 28.1 17.7 28.1 15.3C28 12.1 26.9 9.3 24.7 7.2ZM23.8 21.6C22.3 23.8 20 26.1 16.9 28.7C13.8 26.1 11.5 23.8 9.99995 21.6C8.49995 19.4 7.69995 17.3 7.69995 15.3C7.69995 12.6 8.59995 10.3 10.4 8.6C12.2 6.9 14.4 6 16.9 6C19.4 6 21.5 6.9 23.3 8.6C25.1 10.3 26 12.6 26 15.3C26 17.3 25.3 19.4 23.8 21.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 8.6C21.5 6.9 19.3 6 16.9 6C14.4 6 12.2 6.9 10.4 8.6C8.59995 10.4 7.69995 12.6 7.69995 15.3C7.69995 17.3 8.49995 19.4 9.99995 21.5C11.5 23.6 13.8 26 16.9 28.6C20 26 22.3 23.7 23.8 21.5C25.3 19.3 26.1 17.2 26.1 15.3C26 12.6 25.1 10.4 23.3 8.6Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8999 17.1992C17.3999 17.1992 17.8999 16.9992 18.2999 16.5992C18.6999 16.1992 18.8999 15.7992 18.8999 15.1992C18.8999 14.6992 18.6999 14.1992 18.2999 13.7992C17.8999 13.3992 17.4999 13.1992 16.8999 13.1992C16.3999 13.1992 15.8999 13.3992 15.4999 13.7992C15.0999 14.1992 14.8999 14.6992 14.8999 15.1992C14.8999 15.6992 15.0999 16.1992 15.4999 16.5992C15.8999 16.9992 16.2999 17.1992 16.8999 17.1992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerOfflineAssetHasDevice);
export default __webpack_public_path__ + "static/media/marker_offline_asset_has_device.6512ac4fca9bb059de68e1f4a5196ed5.svg";
export { ForwardRef as ReactComponent };